

import {
    Action,
} from 'one-state';

import {
    SET,
    RESET,
    SETNOTIFICATION
} from './types';

import {
ErrorHandleItem
} from './ErrorHandledata';

/**
 * Redux action creator to set skeleton attibutes 
 * into state
 * @param monitor contains skeleton attibutes either true or false
 * @returns action instance
 */
export const setAction = (monitor: ErrorHandleItem):
    Action<typeof SET> => ({
        type: SET,
        payload: monitor,
    });

export const setNotificationAction = (notification: any):
    Action<typeof SETNOTIFICATION> => ({
        type: SETNOTIFICATION,
        payload: notification,
    }); 

/**
 * Reset the state
 * @returns action instance 
 */
export const resetAction = ():
    Action<typeof RESET> => ({
        type: RESET,
    });

/**
 * List of all valid actions
 */
export type Actions =
    ReturnType<typeof setAction> |
    ReturnType<typeof setNotificationAction> |
    ReturnType<typeof resetAction> ;
